define([
    'jquery',
    'velocity'
], function($, velocity) {

    function UpdateAlertVisibility($alertModule) {
        // Determine the visibility of alerts.
        if ($alertModule) {
            var pageAlertIds = [];

            $alertModule.find("div.alert-content-item").each(function(index) {
                // Determine if this alert should be displayed or not.
                var $this = $(this);
                var alertId = $this.data("alert-id");
                //var alertIds = JSON.parse(localStorage.getItem("DismissedAlertIds"));
                var alertIds = JSON.parse(getCookie("DismissedAlertIds"));
                var isVisible = !alertIds || $.inArray(alertId, alertIds) == -1;

                $this.toggle(isVisible);
                if (isVisible) {
                    pageAlertIds.push(alertId);
                }
            });

            // Now see if there are any alerts left. If not, hide the alert module.
            var showAlerts = pageAlertIds.length > 0;
            $alertModule.toggle(showAlerts);
            $alertModule.attr("aria-hidden", !showAlerts);
        }
    }

    function getCookie(name) {
        // Split cookie string and get all individual name=value pairs in an array
        var cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");

            /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
            if (name == cookiePair[0].trim()) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }

        // Return null if not found
        return null;
    }

    $(".global-alert-container:hidden, .page-alert-container:hidden").each(function(index) {
        var $this = $(this);
        UpdateAlertVisibility($this);
    });

    $(".icon-close").on("click", function() {
        // Close was clicked, Get the id of this alert.
        var $this = $(this);
        var $alertModule = $this.parents('div[role=alert]:first');
        var hideAlertIds = $alertModule.find('div.alert-content-item').map(function(i, e) { return $(e).data('alert-id'); }).get();
        //var dismissedAlertIds = JSON.parse(localStorage.getItem("DismissedAlertIds"));
        var dismissedAlertIds = JSON.parse(getCookie("DismissedAlertIds"));
        // Check to see if there are any alert id's in local storage.
        dismissedAlertIds = dismissedAlertIds ? dismissedAlertIds.concat(hideAlertIds) : hideAlertIds;

        // Add alert id to local storage.
        //localStorage.setItem("DismissedAlertIds", JSON.stringify(dismissedAlertIds));

        var todaysDate = new Date();
        var dateExpires = todaysDate.getSeconds() + window.scan.alertsCookieExpiration;
        dateExpires = new Date(todaysDate.setSeconds(dateExpires));

        document.cookie = "DismissedAlertIds=" + JSON.stringify(dismissedAlertIds) + "; expires=" + dateExpires.toUTCString() + "; path=/";

        UpdateAlertVisibility($alertModule);
    });
});
